import {get,post} from './base.service'

export default{
    /* 查询满意度评价 */
    queryEvaluation(params){
        return get('/app/satisfaction/query',{params:params});
    },
    submitEvaluation(params){
        return post('/app/satisfaction/submit',params)
    }
}


// WEBPACK FOOTER //
// ./src/service/survey.service.js